import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../redux/hooks";
import { useDispatch } from "react-redux";
import { actionUpdateLayerData } from '../../../redux/action/layerData';
import { SensorNodeStatus } from '../../../util/model';
import io from 'socket.io-client';
import { TokenService } from '../../../services/token.service';

import './Map.scss';
import SideBar from './sidebar/SideBar';
import CesiumViewer from './cesium-components/cesiumviewer/CesiumViewer';
import MapInfo from './cesium-components/mapinfo/MapInfo';
import Compass from './cesium-components/compass/Compass';
import Camera from './cesium-components/camera/Camera';
import SNLabel from './cesium-components/sn/SNLabel';
import SNSymbol from './cesium-components/sn/SNSymbol';
import AOA from './cesium-components/aoa/AOA';
import {Viewer} from 'cesium';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';

type SideBarState = 'open' | 'closed';

const Map = () => {
  const [sidebarState, setSidebarState] = useState<SideBarState>('closed');
  const [viewer, setViewer] = useState<Viewer | null>(null);
  const [cameraPos, setCameraPos] = useState<number[]>([0, 0, 0]);
  const [targetPos, setTargetPos] = useState<number[]>([0, 0, 0]);
  const [snIndex, setSNIndex] = useState(-1);

  const dispatch = useDispatch();
  const layerData = useAppSelector((state) => state.layerData);
  const layerConfig = useAppSelector((state) => state.layerConfig);

  const SNTime = layerData.status.Time;
  const SNList = layerData.status.SensorNodes;
  const SNStatus = layerData.status.SensorNodeStatus;

  const cameraSettings = layerConfig.CameraSettings;

  const changeSidebarState = () => {
    setSidebarState((prevState) => (prevState === 'open' ? 'closed' : 'open'));
  };
/*
  useEffect(() => {
    const handleResize = () => {
      const isMobileOrTablet = window.innerWidth <= 768;
      setSidebarState(isMobileOrTablet ? "closed" : "open");
    };

    handleResize(); // Set initial state based on screen size

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
*/
  useEffect(() => {
    const socket = io(window.location.host, {
      reconnectionDelayMax: 10000,
      path: '/api/socket',
      withCredentials: true,
      extraHeaders: {
        'Authorization': `Bearer ${TokenService.getToken()}`,
      }
    });
    socket!.emit('join', 'status');
    socket.on('status', (status: SensorNodeStatus) => {
console.log(status);
      dispatch(actionUpdateLayerData('status', status) as any)
    });
    socket.io.on("reconnect", (attempt) => {
      socket!.emit('join', 'status');
    });
    return () => {
      socket!.emit('leave', '');
    };
  }, []);

  useEffect(() => {
    setSNIndex(-1);
console.log('list changed');
    if(SNList.length > 0) {
      setSNIndex(0);
console.log('sn Index to 0');
    }
  }, [SNList.length]);

  useEffect(() => {
console.log('sn Index changed');
    if (snIndex >= 0 && snIndex < SNList.length) {
console.log('update cam');
      const { Position } = SNStatus[snIndex];
      setTargetPos([Position[0], Position[1], 0.0]);
      setCameraPos([Position[0], Position[1], 1000000]);
    }
  }, [snIndex]);

    useEffect(() => {
        var indexCam = -1;
        for(var i = 0; i < cameraSettings.Cameras.length; ++i) {
            if(cameraSettings.Cameras[i].Name === cameraSettings.CurrentCamera) {
                indexCam = i;
            }
        }
        var indexSN = -1;
        for(var i = 0; i < SNStatus.length; ++i) {
            if(SNStatus[i].Name === cameraSettings.CurrentCamera) {
                indexSN = i;
            }
        }
        var Lon = 0.0;
        var Lat = 0.0;
        var H = 1000000;
        if((indexCam >= 0) && (indexCam < cameraSettings.Cameras.length)) {
            Lon = cameraSettings.Cameras[indexCam].TargetPos[0];
            Lat = cameraSettings.Cameras[indexCam].TargetPos[1];
            H = cameraSettings.Cameras[indexCam].CameraPos[2];
        } else {
            if((indexSN >= 0) && (indexSN < SNStatus.length)) {
                Lon = SNStatus[indexSN].Position[0];
                Lat = SNStatus[indexSN].Position[1];
            }
        }
        setTargetPos([Lon, Lat, 0.0]);
        setCameraPos([Lon, Lat, H]);
    }, [cameraSettings.CurrentCamera])

  return (
    <div className="Map">
      <div className={`map-side ${sidebarState}`}>
        <SideBar width={window.innerWidth}/>
      </div>
      <div className="map-body">
        <div className={`hamburger ${sidebarState}`}>
          <IconButton onClick={changeSidebarState}>
            <MenuIcon />
          </IconButton>
        </div>
        <CesiumViewer callback={setViewer}>
          <div className="map-info">
            <MapInfo time = {SNTime}/>
          </div>
          <Compass />
          <Camera
            camera_position={cameraPos}
            target_position={targetPos}
          />
	  {SNStatus.map((sn, index) => (
            <React.Fragment key={index}>
              <SNSymbol
                pos={sn.Position}
                ground={0}
                size={10}
                status={sn.Status}
              />
              <SNLabel
                label={sn.Name}
                pos={sn.Position}
                ground={0}
                size={0.7}
              />
              {sn.AOA.JammerL1.map((aoa, aoaIndex) => (
                <AOA
                  key={`${index}-jammerL1-${aoaIndex}`}
                  pos={aoa.Pos}
                  ground={0}
                  azi={aoa.Azi}
                  ele={aoa.Ele}
                  range={aoa.Range}
                  width={1}
                  color={'#FFFF00'}
                />
              ))}
              {sn.AOA.SpooferL1.map((aoa, aoaIndex) => (
                <AOA
                  key={`${index}-spooferL1-${aoaIndex}`}
                  pos={aoa.Pos}
                  ground={0}
                  azi={aoa.Azi}
                  ele={aoa.Ele}
                  range={aoa.Range}
                  width={1}
                  color={'#FF0000'}
                />
              ))}
              {sn.AOA.JammerL2.map((aoa, aoaIndex) => (
                <AOA
                  key={`${index}-jammerL2-${aoaIndex}`}
                  pos={aoa.Pos}
                  ground={0}
                  azi={aoa.Azi}
                  ele={aoa.Ele}
                  range={aoa.Range}
                  width={1}
                  color={'#FF8800'}
                />
              ))}
            </React.Fragment>
          ))}
        </CesiumViewer>
      </div>
    </div>
  );
};

export default Map;
